import dynamic from 'next/dynamic';
export var SVGUniqueID = dynamic(function () {
  return import("./react-svg-unique-id");
}, {
  ssr: false
});